import React, { Component } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "../panel/panel.jsx";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#505050",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};

class CreateForm extends Component {
  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/movimientos-productos/mover-producto">
              Movimientos productos
            </Link>
          </li>
          <li className="breadcrumb-item active">Mover</li>
        </ol>
        <h1 className="page-header">Solicitud de movimiento de productos</h1>

        <div className="row">
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <form
                  style={{ margin: "2%" }}
                  onSubmit={this.props.handleSubmit}
                >
                  <fieldset>
                    <legend>Datos de establecimiento que envía</legend>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="actividad">
                            Actividad: <span className="text-danger"> *</span>
                          </label>
                          <Select
                            id="actividad"
                            styles={colourStyles}
                            placeholder="Seleccione"
                            isClearable={false}
                            onChange={this.props.handleActividadChange}
                            theme="neutral40"
                            value={
                              this.props.state.actividad !== null
                                ? this.props.state.actividad
                                : { label: "Seleccione", key: "0" }
                            }
                            options={this.props.state.cat_actividad}
                            getOptionLabel={(actividad) =>
                              actividad.descripcion
                                ? actividad.descripcion.toUpperCase()
                                : null
                            }
                            getOptionValue={(actividad) => actividad.id}
                            noOptionsMessage={() =>
                              "No se encontraron actividades"
                            }
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="actividad-error"
                          ></div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="establecimiento">
                            Establecimiento:{" "}
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            id="establecimiento"
                            styles={colourStyles}
                            placeholder="Seleccione"
                            isClearable={false}
                            onChange={this.props.handleEstablecimientoChange}
                            theme="neutral40"
                            value={
                              this.props.state.establecimiento !== null
                                ? this.props.state.establecimiento
                                : { label: "Seleccione", key: "0" }
                            }
                            options={this.props.state.cat_establecimiento}
                            getOptionLabel={(establecimiento) =>
                              establecimiento.razon_social
                                ? establecimiento.razon_social.toUpperCase()
                                : null
                            }
                            getOptionValue={(establecimiento) =>
                              establecimiento.id
                            }
                            noOptionsMessage={() =>
                              "No se encontraron establecimientos"
                            }
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="establecimiento-error"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </fieldset>

                  <br />

                  <fieldset>
                    <legend>Datos de establecimiento que recibe</legend>

                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="razon_social">
                            Razón social <span className="text-danger"> *</span>
                          </label>

                          <input
                            type="text"
                            name="razon_social"
                            id="razon_social"
                            onChange={this.props.handleRazonSocialChange}
                            value={this.props.state.razon_social}
                            className="form-control"
                            placeholder="Ingrese razón social del establecimiento"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="razon_social-error"
                          ></div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="actividad_recibe">
                            Actividad: <span className="text-danger"> *</span>
                          </label>
                          {this.props.state.guidValidado ? (
                            <div
                              id="actividad_recibe"
                              name="actividad_recibe"
                              className="form-control"
                            >
                              {this.props.state.actividad_recibe_nombre}
                            </div>
                          ) : (
                            <select
                              name="actividad_recibe"
                              id="actividad_recibe"
                              onChange={this.props.handleActividadRecibeChange}
                              className="form-control"
                              value={this.props.state.actividad_recibe_id}
                            >
                              <option value="" disabled>
                                Seleccione
                              </option>
                              {this.props.state.cat_actividad_recibe.length > 0
                                ? this.props.state.cat_actividad_recibe.map(
                                    (el, index) => (
                                      <option
                                        key={index}
                                        value={el.id}
                                        data-descripcion={el.descripcion.toUpperCase()}
                                      >
                                        {el.descripcion.toUpperCase()}
                                      </option>
                                    )
                                  )
                                : null}
                            </select>
                          )}
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="actividad_recibe-error"
                          ></div>
                        </div>
                      </div>

                      <div className="col-lg-5">
                        <div className="form-group">
                          <label htmlFor="guid">
                            GUID <span className="text-danger"> *</span>
                          </label>

                          <input
                            type="text"
                            name="guid"
                            id="guid"
                            onChange={this.props.handleRazonSocialChange}
                            value={this.props.state.guid}
                            className="form-control"
                            maxLength="4"
                            placeholder="Ingrese GUID"
                          />
                          <div
                            className="invalid-feedback"
                            style={{ display: "none" }}
                            id="guid-error"
                          ></div>
                        </div>
                      </div>
                      <div className="col-lg-1">
                        <label className="m-0" htmlFor="guidBtn">
                          &nbsp;
                        </label>
                        <button
                          type="button"
                          id="guidBtn"
                          title="Buscar establecimiento"
                          onClick={this.props.handleGuidEstablecimiento}
                          className="btn btn-light btn-block"
                        >
                          <i className="fa fa-th"></i>
                        </button>
                      </div>
                    </div>
                  </fieldset>

                  <hr />

                  <div className="row">
                    <div className="col-lg-12">
                      <button className="btn btn-success btn-block">
                        Generar
                      </button>
                    </div>
                  </div>
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateForm;
